import Button from '@mui/material/Button';

import { createStyles, makeStyles } from '@mui/styles';

//| import { Theme } from '@mui/material/styles';
import { useTheme ,Theme  } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import BoltMarginlessIcon from '../../assets/BoltMarginlessIcon';

import styles from '../../styles/_variables.module.scss';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      fontWeight: Number(styles.normalTextWeight),
      height: 'fit-content',
      marginRight: '1rem',
      '& .MuiButton-startIcon': {
        color: styles.white,
        marginRight: '0.5rem',
      },
      [theme.breakpoints.down('lg')]: {
        margin: 0,
      },
    },
  }),
);

function OnTheFlyButton() {
  const classes = useStyles(useTheme());
  const navigate = useNavigate();

  return (
    <Button
      disableElevation
      className={classes.button}
      color="secondary"
      variant="contained"
      startIcon={<BoltMarginlessIcon color={styles.white} />}
      onClick={() => navigate('/on-the-fly-payments')}
    >
      Pago rápido
    </Button>
  );
}

export default OnTheFlyButton;

